define([
	"dojo/has",
	"dojo/topic",
	"dojo/keys",
	"froalaEditor",
	"jquery",

	"froalaalign",
	"froalachar_counter",
	"froalacolors",
	"froaladraggable",
	"froalaemoticons",
	"froalaentities",
	"froalafile",
	"froalafont_family",
	"froalafont_size",
	"froalafullscreen",
	"froalaimage",
	"froalaimage_manager",
	"froalainline_style",
	"froalaline_breaker",
	"froalalink",
	"froalalists",
	"froalaparagraph_format",
	"froalaparagraph_style",
	"froalaquote",
	"froalasave",
	"froalatable",
	"froalaurl",
	"froalavideo",
	"froalaword_paste"
], function(has, topic, keys, froalaEditor, $) {

	//customize insert link to handle both edit link and insert link
	froalaEditor.RegisterCommand('insertLink', {
		title: 'Insert Link',
		focus: true,
		refreshOnCallback: false,
		popup: true,
		callback: function() {
			if (!this.popups.isVisible('link.insert')) {
				this.link.showInsertPopup();
			} else {
				if (this.$el.find('.fr-marker')) {
					this.events.disableBlur();
					this.selection.restore();
				}
				this.popups.hide('link.insert');
			}
			//hide the search dropdown link row as there are no predefined links to show
			this.popups.get('link.insert').find('.fr-buttons').hide();
		},
		plugin: 'link'
	});

	// Register shortcut for CTRL + Y for redo operation
	froalaEditor.RegisterShortcut(89, 'redo');

	froalaEditor.PLUGINS.CentricToolbar = function(editor) {
		// This object is used to map our toolbar plugins values with froala current selection
		var _textStyles = [{name: 'strong', value: 'strong'}, {name: 'em', value: 'italic'}, {name: 'u', value: 'underline'}, {name: 's', value: 'strikethrough'}, {name: 'OL', value: 'OL'}, {name: 'UL', value: 'UL'}];

		// froala default paragraph styles
		var _paragraphStyles = ['N', 'H1', 'H2', 'H3', 'H4'];

		// Return current selection color
		function _getSelectionColor() {
			var element = editor.selection.element();
			var elementStyle = element.style;
			var computedStyle = window.getComputedStyle(element, null);
			for (prop in elementStyle) {
				if (elementStyle.hasOwnProperty(prop) && prop === 'color') {
					return editor.helpers.RGBToHex(computedStyle[prop]);
					break;
				}
			}
		}

		// handle the froala editor events
		function handleEditorEvents(event) {
			var textAttrs = {};

			// Current selection alignment
			textAttrs['left'] = 'left';
			var blocks = editor.selection.blocks();
			if (blocks.length) {
				var alignment = editor.helpers.getAlignment($(blocks[0]));
				textAttrs[alignment] = alignment;
			}

			// get the selection style like bold, italic, underline and strikethrough
			_textStyles.forEach(element => {
				if (editor.format.is(element.name)) {
					textAttrs[element.value] = element.value;
				}
			});

			// Current selection color style
			textAttrs['color'] = _getSelectionColor();

			// Current selection font size
			textAttrs['font-size'] = editor.helpers.getPX($(editor.selection.element()).css('font-size'));

			// get the selection paragraphy style
			textAttrs['paragraph'] = _paragraphStyles[0];

			_paragraphStyles.forEach(style => {
				if (editor.format.is(style)) {
					textAttrs['paragraph'] = style;
				}
			});


			// Current selection font Family
			// Example: froala using '\'Times New Roman\',Times,serif' as default for the Times New Roman
			// So '\'Times New Roman\',Times,serif'.replace(/"/g,'\'').replace(/, /g, ',') will be return "'Times New Roman',Times,serif"
			// finally fontFamily.replace(/[']+/g, ''); will return "Times New Roman,Times,serif"
			var fontFamily = $(editor.selection.element()).css('font-family').replace(/"/g, '\'').replace(/, /g, ',');
			textAttrs['font-family'] = fontFamily.replace(/[']+/g, '');

			// publish event that can be listen in svgCanvas and use attributes to update toolbar
			topic.publish("/csi/svg/froala", {
				attributes: textAttrs,
				event: event,
				isEscape: event && (event.keyCode === keys.ESCAPE),
				scrollHeight: $(editor.$el[0])[0].scrollHeight
			});
		}

		// Set caret at the end of content
		function setCaretAtEnd() {
			editor.selection.setAtEnd(editor.$el.get(0));
			editor.selection.restore();
		}

		// Clear selected text formatting
		function clearFormatting() {
			editor.commands.clearFormatting();
		}

		// Check current selection format
		function checkFormat(format) {
			return editor.format.is(format);
		}

		// Apply style on current selection
		function applyTextStyle(data) {
			switch (data.style) {
				case 'strong':
					editor.commands.bold();
					break;
				case 'italic':
					editor.commands.italic();
					break;
				case 'underline':
					editor.commands.underline();
					break;
				case 'strikethrough':
					editor.commands.strikeThrough();
					break;
				case 'center':
				case 'left':
				case 'right':
					editor.align.apply(data.style);
					break;
				case 'color':
					if (editor.selection.inEditor()) {
						editor.colors.text(data.value);
					}
					break;
				case 'font-size':
					editor.fontSize.apply(data.value);
					break;
				case 'font-family':
					editor.fontFamily.apply(data.value);
					break;
				case 'indent':
					editor.commands.indent();
					break;
				case 'outdent':
					editor.commands.outdent();
					break;
				case 'UL':
				case 'OL':
					editor.lists.format(data.style);
					break;
				case 'paragraph':
					editor.paragraphFormat.apply(data.value);
					break;
			}
			// update toolbar after applying style
			handleEditorEvents();
		}

		// publish event on text content changes
		function handleContentChangeEvents() {
			topic.publish("/csi/svg/updateThumbnail");
		}

		// Start point for plugin.
		function _init() {
			// listen for froala events
			editor.events.on('keyup', handleEditorEvents);
			editor.events.on('click', handleEditorEvents);
			editor.events.on('contentChanged', handleContentChangeEvents);
		}
		// Public method can be accessed through the editor API:
		return {
			_init: _init,
			applyTextStyle: applyTextStyle,
			setCaretAtEnd: setCaretAtEnd,
			clearFormatting: clearFormatting,
			checkFormat: checkFormat
		}
	};

	// This code was commented out before upgrading to Froala 3.1 so leaving
	// it here commented for now.
	// Commenting custom Quick Insert buttons for now
	// 	froalaEditor.QUICK_INSERT_BUTTONS.link = {
	// 	 icon: "insertLink",
	// 	 callback: function() {
	// 			 this.quickInsert.hide(),
	// 			 this.popups.show("link.insert"),
	// 			 this.undo.saveStep()
	// 	 },
	// 	 title: "Insert Link"
	//  };
	//  froalaEditor.QUICK_INSERT_BUTTONS.undo = {
	// 	icon: "undo",
	// 	callback: function() {
	// 			this.quickInsert.hide(),
	// 			this.commands.undo(),
	// 			this.undo.saveStep()
	// 	},
	// 	title: "Insert Link"
	// };
	// froalaEditor.QUICK_INSERT_BUTTONS.redo = {
	//  icon: "redo",
	//  callback: function() {
	// 		 this.quickInsert.hide(),
	// 		 this.commands.redo(),
	// 		 this.undo.saveStep()
	//  },
	//  title: "Insert Link"
	// };

	return froalaEditor;
});
